<template>
    <div>
        <b-row class="">
            <b-col cols="12" lg="5">
                <h6 class="f-110 mb-3">{{ $t(`등록된 사용자`) }} </h6>
                <div v-if="company_users.length > 0" class="">
                    <b-button v-for="(item, index) in company_users"
                              :key="item.id"
                              :class="[{'f-90 p-2': is_editing }, 'f-95 text-left p-0 w-100 p-1 mb-2']"
                              :variant="e_mail == item.user.e_mail && is_editing == true ? 'blue-border' : 'white-dark'"
                              :disabled="is_user_updating"
                              @click="editUser(item)"
                    >
                        {{ index + 1 }}. {{ item.user.user_name }}
                        <b-badge class="mr-2">{{ item.user_id }}</b-badge>
                        <b-badge :variant="e_mail == item.user.e_mail && is_editing == true ? 'blue-basic' : 'basic'"
                                 class="mr-2"
                        >
                            <span v-if="item.role === 2">{{ $t(`평가 관리자`) }}</span>
                            <span v-else>{{ $t(`일반 참여자`) }}</span>
                        </b-badge>
                        <b-badge :variant="request_access_variant[item.access_status]"
                                 class="mr-2"
                        >

                            <span>{{ $t(request_access[item.access_status]) }}</span>
                        </b-badge>
                        <b-badge v-if="me.role === 2 || me.user.is_admin === 4"
                                 :variant="e_mail == item.user.e_mail && is_editing == true ? 'blue-basic' : 'basic'"
                        >
                            <span v-if="item.user.is_admin === 1">{{$t(`일반 사용자`) }}</span>
                            <span v-if="item.user.is_admin === 2">{{$t(`외부 평가자`) }}</span>
                            <span v-if="item.user.is_admin === 3">{{$t(`캠페인 평가자`) }}</span>
                            <span v-if="item.user.is_admin === 4">{{$t(`최고 관리자`) }}</span>
                        </b-badge>
                    </b-button>
                </div>
                <div v-else-if="company_users.length == 0 && is_editing != true" class="text-center">
                    <b-card class="bgray-100 border-0 text-center mt-2 mb-2 f-90 gray-550">
                        {{ $t(`등록된 사용자가 없습니다. 신규 사용자를 등록해 주세요.`) }}
                    </b-card>
                </div>
            </b-col>
            <template v-if="is_editing !== true && company_users.length > 0">
                <b-col cols="12" lg="7" class="">
                    <div class="d-flex align-items-end justify-content-between mb-3">
                        <h6 class="f-105 mb-0">
                            {{ $t(`신규 사용자 초대`) }}
                        </h6>

                        <p class="f-90 fw-400 mb-0">{{ $t('한번에 최대 3명까지 초대 가능합니다.') }}</p>
                    </div>

                    <b-card :class="['bgray-300 border-0']">
                        <b-form-group v-for="(member, m) in newMembers"
                                      :key="`new-member-${m}-input-group`"
                                      :state="member.state"
                                      :invalid-feedback="member.feedback"
                                      :class="[{'mt-3': m !== 0}, 'mb-0']"
                        >
                            <b-form-input
                                type="email"
                                :value="member.value"
                                :state="member.state"
                                :placeholder="$t('이메일 주소')"
                                :disabled="is_inviting"
                                autocomplete="new-password"
                                @input="checkEmail($event, m)"
                            />
                        </b-form-group>

                        <div class="d-flex align-items-center justify-content-between mt-4">
                            <p class="f-90 mb-0">
                                {{
                                    inviting_complete_state === null
                                        ? ''
                                        : inviting_complete_state === true
                                            ? this.$t('평가참여 초대를 완료하였습니다.')
                                            : this.$t("죄송합니다. '참여자 수정하기' 창을 닫은 신 후 다시 시도해주세요.")
                                }}
                            </p>

                            <div>
                                <b-btn variant="primary" size="sm" class="mr-2" :disabled="is_inviting"
                                       @click="inviteNewMember">
                                    {{ $t(`참여자 초대하기`) }}
                                </b-btn>

                                <b-btn variant="danger" size="sm" :disabled="is_inviting" @click="initializeMemberForm">
                                    {{ $t('초기화') }}
                                </b-btn>
                            </div>
                        </div>
                    </b-card>
                </b-col>
            </template>
            <!-- v-if="is_editing == true" -->
            <template v-else>
                <b-col cols="12" lg="7" class="">
                    <h6 class="f-110 mb-3 pl-3">
                        <!-- {{ is_editing_new !== true ? $t(`사용자 정보 수정`) : $t(`신규 사용자 초대`) }} -->
                        {{ $t(`사용자 정보 수정`) }}
                    </h6>
                    <div class="border-left pl-3">
                        <b-table-simple hover class="input-table f-90 overflow-auto">
                            <b-tbody>
                                <b-tr>
                                    <b-td style="width:30%">{{ $t(`성함`) }}*</b-td>
                                    <b-td> {{ user_name }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td style="width:30%">{{ $t(`소속 회사`) }}</b-td>
                                    <b-td>{{ temp_company_name }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td style="width:30%">{{ $t(`이메일 (로그인 ID)`) }}*</b-td>
                                    <b-td> {{ e_mail }}</b-td>
                                </b-tr>
                                <template v-if="is_manager || is_admin || $store.state.e_mail === e_mail">
                                    <b-tr>
                                        <b-td style="width:30%"> {{ $t(`비밀번호 설정`) }}</b-td>
                                        <b-td>
                                            <b-button variant="dark-border" block class="py-1 "
                                                      :disabled="is_changing_password"
                                                      @click="sendPassword"
                                            >
                                                <div class="d-flex align-items-center justify-content-center">
                                                    <b-spinner v-if="is_changing_password"
                                                               style="width: 1rem;height: 1rem;"
                                                               class="mr-2"/>
                                                    <span class="f-90">
                                                        {{ $t(`비밀번호 재발급`) }}
                                                    </span>
                                                </div>
                                            </b-button>
                                        </b-td>
                                    </b-tr>
                                </template>
                                <b-tr v-if="(me && me.role === 2) || (me && me.user.is_admin === 4)">
                                    <b-td> {{ $t(`평가 참여`) }}</b-td>

                                    <b-td class="text-left">
                                        <b-form-group class="mb-0">
                                            <b-form-radio v-model="role" value="1" class="f-90"
                                                          :disabled="is_user_updating || me.user_id === user_id"
                                            >
                                                {{ $t(`일반 참여자`) }} (lv.1)
                                            </b-form-radio>
                                            <b-form-radio v-model="role" value="2" class="f-90"
                                                          :disabled="is_user_updating || me.user_id === user_id"
                                            >
                                                {{ $t(`평가 관리자`) }} (lv.2)
                                            </b-form-radio>
                                        </b-form-group>
                                    </b-td>
                                </b-tr>
                                <b-tr v-if="(me && me.role === 2) || (me && me.user.is_admin === 4)">
                                    <b-td> {{ $t(`평가 참여 상태`) }}</b-td>

                                    <b-td class="text-left">
                                        <b-badge :variant="request_access_variant[access_status]"
                                                 class="mr-2"
                                        >

                                            <span>{{ $t(request_access[access_status]) }}</span>
                                        </b-badge>
                                    </b-td>
                                </b-tr>
                                <b-tr v-if="me && me.user.is_admin === 4">
                                    <b-td> {{ $t(`권한 레벨`) }}</b-td>
                                    <b-td class="text-left">
                                        <b-form-group class="mb-0">
                                            <b-form-radio v-model="is_admin" value="1" class="f-90"
                                                          :disabled="is_user_updating">{{ $t(`일반 사용자`) }} (lv.1)
                                            </b-form-radio>

                                            <b-form-radio v-model="is_admin" value="2" class="f-90"
                                                          :disabled="is_user_updating">{{ $t(`외부 평가자`) }} (lv.2)
                                            </b-form-radio>
                                            <b-form-radio v-model="is_admin" value="3" class="f-90"
                                                          :disabled="is_user_updating">{{ $t(`캠페인 평가자`) }} (lv.3)
                                            </b-form-radio>
                                            <b-form-radio v-model="is_admin" value="4" class="f-90"
                                                          :disabled="is_user_updating">{{ $t(`최고 관리자`) }} (lv.4)
                                            </b-form-radio>
                                        </b-form-group>
                                    </b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>

                        <div class="mt-3 text-right">
                            <b-button size="sm" variant="blue"
                                      :disabled="is_user_updating || !is_able_saving"
                                      @click="saveUser"
                            >
                                <fa icon="check" class="mr-1"></fa>
                                {{ $t(`저장`) }}
                            </b-button>
                            <b-button class="ml-2" size="sm" variant="danger"
                                      :disabled="is_user_updating || (target_uesr && target_uesr.role === 2)"
                                      @click="deleteUser"
                            >
                                {{ $t(`삭제`) }}
                            </b-button>
                            <b-button :disabled="is_user_updating" class="ml-2" size="sm" variant="dark"
                                      @click="handleCancel">
                                {{ $t(`취소`) }}
                            </b-button>
                        </div>

                    </div>
                </b-col>
            </template>
        </b-row>

        <b-card v-show="is_failed.status" bg-variant="danger" class="text-light">
            <BIconExclamationTriangleFill class="mr-2"/>
            <!-- <span>{{ $t('죄송합니다. 수정 중 오류가 발생했습니다. 참여자 수정하기 창을 닫고 다시 시도해주세요.') }}</span> -->
            <span>{{ $t('죄송합니다.') }}</span>
            <span>{{ $t(is_failed.messgae) }}</span>
            <span>{{ $t('참여자 수정하기 창을 닫고 다시 시도해주세요.') }}</span>
        </b-card>

        <!-- <b-card v-if="isAdminDefined==true" :class="[company_users.length>0?'':'border-0','f-90 bgray-100 text-black-50 ']">
            <b-badge variant="basic f-80 mt-1 mr-1"> {{$t(`캠페인 리더`)}} </b-badge>{{$t(`는 신규 참여자를 추가하거나 문항 작성 권한을 조정할 수 있는 관리자입니다.`)}}
        </b-card>
        <b-card v-else class="f-90 bgray-100 text-black-50 border-0">   
            <fa icon="exclamation-circle" class="mr-1"></fa>
            <b>{{ selected_company.company_name }}의 캠페인 리더가 등록되어 있지 않습니다. 캠페인 리더를 등록하여 주십시오.</b>
            <div class="mt-1">캠페인 리더는 신규 참여자를 추가하거나 문항 작성 권한을 조정할 수 있는 관리자입니다. </div>
        </b-card> -->
    </div>
</template>

<script>
import {mapState, mapMutations} from 'vuex';
import {debounce} from 'lodash';

export default {
    name: 'UserRegistrationForm_v2',
    props: {
        // company_users: { type:Array, default:()=>[] },
        //target_company_id: { default: '' }
        users_in_company: {
            type: Array,
            default: () => []
        },
        is_manager: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            user_id: '',
            user_name: '',
            e_mail: '',
            company_id: '',
            role: '',
            is_admin: 0,
            target_uesr: null,
            access_status: null,

            is_editing: false,
            is_editing_new: false,
            is_password_change: false,
            is_changing_password: false,
            is_user_updating: false,
            is_user_deleting: false,
            is_able_saving: false,
            // is_failed: false,
            is_failed: {
                status: false,
                messgae: '참여자 수정하기 창을 닫고 다시 시도해주세요.'
            },


            newMembers: [
                {value: null, state: null, feedback: null},
                {value: null, state: null, feedback: null},
                {value: null, state: null, feedback: null}
            ],
            is_inviting: false,
            inviting_complete_state: null,
            request_access: {
                0: '승인',
                1: '대기',
                2: '거부'
            },
            request_access_variant: {
                0: 'success',
                1: 'info',
                2: 'warning'
            },
        };
    },
    computed: {
        ...mapState(['question_composition', 'admin_mode', 'campaign', 'view_mode', 'selected_company', 'company_name']),
        ...mapState('questions', ['subs', 'subs_loaded']),
        // ...mapState('campaign_users', ['users_in_company']),
        current_campaign_id() {
            return this.$route.query.cmp ?? this.$route.query.campaign_id;
        },
        company_users() {
            return this.users_in_company;
        },
        temp_company_name() {
            return this.company_name;
        },
        is_company_selected() { //관리자 화면에서 사용
            if (this.$store.state.selected_company.company_id != '') return true;
            else return false;
        },
        all_users() { //관리자 화면에서 사용
            return [...this.$store.state.selected_company.all_users];
        },
        admin_level() {
            return this.$store.getters.getAdminLevel;
        },
        logined_admin() {
            return this.$store.state.is_admin;
        },
        disable_by_admin_lv() {
            if (this.view_mode == 'provider') {
                return this.is_admin >= 1;
            } else {
                return this.logined_admin < 3;
            }
        },
        isAdminDefined() {
            if (this.view_mode == 'provider') {
                // provider 화면일때
                let idx = this.company_users.findIndex(item => item.is_admin >= 1);
                if (idx > -1) return true;
                else return false;
            } else { // 관리자 화면일 경우 
                if (this.selected_company['all_users']) {
                    let idx = this.selected_company.all_users.findIndex(item => item.is_admin >= 1);
                    if (idx > -1) return true;
                    else return null;
                } else {
                    return false;
                }
            }
        },
        me() {
            if (!this.company_users || !this.company_users.length) {
                return null;
            } else {
                return this.company_users.find(_participant => _participant.user_id === Number(this.$store.state.user_id));
            }
        }
    },
    watch: {
        role(_updated_role) {
            if (_updated_role !== null && this.target_uesr?.role) {
                this.is_able_saving = this.target_uesr?.role !== Number(_updated_role);
            } else {
                this.is_able_saving = false;
            }
        },
        is_admin(_updated_is_admin) {
            if ((_updated_is_admin !== null && ![0, 1].includes(_updated_is_admin)) && this.target_uesr?.user?.is_admin !== null) {
                this.is_able_saving = this.target_uesr?.user?.is_admin !== Number(_updated_is_admin);
            } else {
                this.is_able_saving = false;
            }
        }
    },
    created() {

    },
    methods: {
        ...mapMutations('campaign_users', ['update_users_in_company']),
        editUser(user) {
            this.is_editing = true;
            this.target_uesr = {...user};

            this.user_id = null;
            this.user_name = null;
            this.e_mail = null;
            this.company_id = null;
            this.role = null;
            this.is_admin = null;
            this.access_status = null;

            this.$nextTick(() => {
                // this.is_editing_new = false
                this.user_id = user.user_id;
                this.user_name = user.user.user_name;
                this.e_mail = user.user.e_mail;
                this.company_id = user.company.id;
                this.role = user.role;
                this.is_admin = user.user.is_admin;
                this.access_status = user.access_status;
                this.is_able_saving = false;
            });
        },
        async saveUser() {
            try {
                this.is_user_updating = true;
                let updating_target_user = this.company_users.find(({user_id}) => user_id === this.user_id);
                if (updating_target_user.user.is_admin !== this.is_admin) {
                    const _updated_user = await this.$axios.post('/users/role', {
                        user_id: this.user_id,
                        is_admin: this.is_admin
                    });
                    this.$emit('update-user', _updated_user.data);
                }

                if (updating_target_user.role !== this.role) {
                    if(this.access_status !== 0){
                        this.$EventBus.$emit('toast-failure', this.$t('참여자 수정하기'), this.$t('평가 참여 상태가 승인된 사용자만 참여자 권한을 변경할 수 있습니다.'));
                        return;
                    }
                    
                    const h = this.$createElement;
                    this.$showModal({
                        type: 'confirm',
                        state: 'warning',
                        title: this.$t('평가 관리자 권한 양도'),    
                        message: h('div', {}, [
                            h('div', {}, this.$t('평가 관리자 권한을 다른 사용자에게 양도하시겠습니까?')),
                            h('div', {class: 'mt-2 font-weight-bold'}, this.$t('현재 평가 관리자는 일반 참여자로 변경되고, 선택한 사용자가 평가 관리자가 됩니다.')),
                            h('div', {class: 'mt-2'}, this.$t('또한 양측 모두 로그아웃 처리되며 다시 로그인해야 권한이 적용됩니다.')),
                        ])
                    })
                        .then(async (v)=>{
                            if(!v) return;
                            await this.$axios.put('/vendor_codes/manager', {
                                current_manager_id: this.$store.state.user_id,
                                next_manager_id: this.user_id,
                                company_id: this.company_id,
                                campaign_id: this.current_campaign_id
                            });


                            const {data: user_list} = await this.$axios.get('/company/members', {
                                params: {
                                    company_id: this.company_id,
                                    campaign_id: this.current_campaign_id
                                }
                            });

                            this.$emit('update-members', user_list);
                            
                            
                        });
                    
                   
                }
            } catch (error) {
                if (error.response) {
                    const response = error.response;
                    const message = error.response.message;
                    let _err_message = null;

                    if (response.status === 404) {
                        if (message === 'current manager not exist') {
                            _err_message = '현재 기업 평가 관리자가 조회되지 않습니다.';
                        } else if (message === 'Next manager not exist') {
                            _err_message = '기업 평가 관리자 권한을 받을 사용자를 조회할 수 없습니다.';
                        }
                    } else if (response.status === 403) {
                        if (message === 'Current Manager Not Authorized') {
                            _err_message = '현재 기업 평가 관리자 권한을 가지고 있지 않습니다.';
                        } else if (message === 'Next Manager Not Authorized') {
                            _err_message = '기업 평가 관리자 권한을 받을 사용자에게 권한이 없습니다.';
                        }
                    }

                    if (!_err_message) {
                        _err_message = '수정 중 오류가 발생했습니다.';
                    } else {
                        _err_message = `${_err_message}`;
                    }


                    this.is_failed.messgae = _err_message;
                }

                this.is_failed.status = true;
            } finally {
                this.is_user_updating = false;
            }
        },
        async inviteNewMember() {
            const h = this.$createElement;

            try {
                let _inviting_list = [];
                let input_null_cnt = 0;
                this.is_inviting = true;
                this.inviting_complete_state = null;
                this.newMembers.forEach(_member => {
                    _member.state = null;
                    _member.feedback = null;
                });

                const _current_user_email = this.users_in_company.reduce((_emails, {user}) => {
                    _emails.push(user.e_mail);
                    return _emails;
                }, []);

                this.newMembers.forEach((member) => {
                    if (member.value) {
                        const is_valid_email = /^[A-Za-z0-9_\.\-]+@[A-Za-z0-9\-]+\.[A-za-z0-9\-]+/.test(member.value);
                        const _is_existed = _current_user_email.includes(member.value);
                        if (is_valid_email === false || _is_existed === true) {
                            member.state = false;

                            if (is_valid_email === false) {
                                member.feedback = this.$t('유효하지 않은 이메일입니다. 확인 후 재시도해주세요');
                            } else if (_is_existed === true) {
                                member.feedback = this.$t('이미 참여중인 계정입니다.');
                            }
                        } else {
                            _inviting_list.push(member.value);
                        }
                    } else {
                        input_null_cnt += 1;
                    }
                });

                if (input_null_cnt === 3) {
                    this.$EventBus.$emit('toast-failure', this.$t('참여자 초대'), h('div', {}, [
                        h('div', {}, this.$t('참여자 초대에 실패했습니다.')),
                        h('div', {}, this.$t('이메일 주소를 입력해주세요.')),
                    ]));
                    return;
                }


                if (_inviting_list.length) {
                    const {project_code} = this.$store.state.campaign_in_progress;

                    let _res_invitation = await this.$axios.post('/company/invite', {
                        project_code,
                        company_id: this.me.company.id,
                        user_id: this.me.user_id,
                        invitaion_mail: _inviting_list
                    });

                    const {not_valid_email} = _res_invitation.data;
                    if (not_valid_email.length) {
                        this.checkInvalidEmail(not_valid_email);
                    }


                    this.$EventBus.$emit('toast-success', this.$t('참여자 초대'), h('div', {}, [
                        h('div', {}, this.$t('참여자 초대를 완료하였습니다.')),
                        h('div', {}, this.$t('초대된 참여자는 이메일을 통해 참여 안내를 받게 되며, 참여자가 참여 신청을 완료하면 등록된 이메일을 통해 승인 또는 거부할 수 있습니다.')),
                    ]), false, 5000);

                    this.inviting_complete_state = true;
                } else {
                    this.$EventBus.$emit('toast-failure', this.$t('참여자 초대'), h('div', {}, [
                        h('div', {}, this.$t('참여자 초대에 실패했습니다.')),
                        h('div', {}, this.$t('메시지를 확인해주세요.')),
                    ]));
                }

            } catch (error) {
                if (error.response) {
                    const {status, message, data} = error.response;
                    if (status === 404) {
                        if (message === 'Not Found Vendor') {
                            this.inviting_complete_state = false;
                        } else if (message === 'Not Found Company') {
                            this.inviting_complete_state = false;
                        }

                        this.inviting_complete_state = false;
                    } else if (status === 400) {
                        const {not_valid_email} = data;
                        if (not_valid_email.length) {
                            this.checkInvalidEmail(not_valid_email);
                        }
                    }
                } else {
                    this.inviting_complete_state = false;
                }

                this.$EventBus.$emit('toast-failure', this.$t('참여자 초대'), h('div', {}, [
                    h('div', {}, this.$t('참여자 초대에 실패했습니다.')),
                    h('div', {}, this.$t('메시지를 확인해주세요.')),
                ]));
            } finally {
                this.is_inviting = false;
            }
        },
        checkInvalidEmail(invalid_email_list) {
            invalid_email_list.forEach(_invalid_email => {
                let _email_idx = this.newMembers.findIndex(({value}) => value === _invalid_email);
                this.$set(this.newMembers[_email_idx], 'state', false);
                this.newMembers[_email_idx].state = false;
                this.newMembers[_email_idx].feedback = this.$t('유효하지 않은 이메일입니다. 확인 후 재시도해주세요');
            });
        },
        checkEmail: debounce(function ($event, _member_idx) {
            if (this.newMembers[_member_idx].state !== null) {
                if (this.newMembers[_member_idx].value !== $event) {
                    this.newMembers[_member_idx].state = null;
                    this.newMembers[_member_idx].feedback = null;
                }
            }

            this.newMembers[_member_idx].value = $event;
        }, 500),
        initializeMemberForm() {
            this.newMembers = [
                {value: null, state: null, feedback: null},
                {value: null, state: null, feedback: null},
                {value: null, state: null, feedback: null}
            ],
            this.is_inviting = false;
            this.inviting_complate_state = null;
        },
        async deleteUser() {
            try {
                this.is_user_deleting = true;
                let confirm_delete_user = confirm(this.$t('해당 사용자를 삭제하면 평가에 참여할 수 없습니다. 삭제하시겠습니까?'));
                if (confirm_delete_user) {
                    const user_id = this.target_uesr.user_id;
                    const company_id = this.company_id;
                    const {request_id} = this.$store.state.campaign_in_progress;

                    const _res_user_deleted = await this.$axios.delete('/company/members', {
                        data: {user_id, company_id, request_id}
                    });

                    this.$emit('update-members', _res_user_deleted.data);
                }


                // if (this.e_mail !== '' && this.e_mail !== this.$store.state.e_mail) {
                //     let confirm_delete_user = confirm(this.$t('삭제하면 사용자 설정이 모두 지워지며, 되돌릴 수 없습니다. 삭제하시겠습니까?'))

                //     if (confirm_delete_user === true) {
                //         let formData = new FormData()
                //         formData.append('e_mail', this.e_mail)
                //         await this.$axios.post('/delete_user', formData)

                //         if (this.view_mode === 'provider') {
                //             let idx = this.company_users.findIndex(item => item.e_mail === this.e_mail)
                //             if (idx > -1) {
                //                 this.company_users.splice(idx, 1)
                //             }
                //             this.update_users_in_company(this.company_users)  
                //         } else {
                //             //관리자 화면일 경우  
                //             let temp_company = ih.deepCopy(this.selected_company)
                //             let idx = temp_company.all_users.findIndex(item => item.e_mail == this.e_mail)
                //             if(idx > -1) {
                //                 temp_company.all_users.splice(idx, 1)
                //                 this.company_users.splice(idx, 1)
                //             }
                //             this.$store.commit('update_selected_company', temp_company)

                //         }

                //         this.$emit('toast-success', this.$t('삭제'), this.$t(`사용자를 삭제하였습니다.`))
                //         this.initiateForm()
                //     }                
                // } else {
                //     alert('삭제 가능한 유저 정보가 없습니다.')
                //     this.initiateForm()
                // }
            } catch (error) {
                if (error.response) {
                    console.log(' ~ error.response => ', error.response);
                } else {
                    console.log(' ~ error => ', error);
                }
            } finally {
                this.is_user_deleting = false;
            }
        },
        initiateForm() {
            this.user_id = null;
            this.user_name = null;
            this.e_mail = null;
            this.role = null;
            this.is_admin = null;
            this.is_user_updating = false;
            this.is_able_saving = false;
            this.target_uesr = null;
        },
        handleCancel() {
            this.is_editing = false;
            this.initiateForm();
        },
        async sendPassword() {
            try {
                this.is_changing_password = true;

                //  입력 받은 이메일로 User 정보를 찾음
                await this.$axios.get('/find_user_by_email', {
                    params: {
                        e_mail: this.e_mail,
                        mode: 'qesg_assessment',
                        lang: this.$i18n.locale
                    }
                });

                this.$EventBus.$emit('toast-success', this.$t('비밀번호 재설정 완료'), this.$t('임시 비밀번호를 선택한 사용자의 이메일로 발송하였습니다.'));


                this.isSuccess.state = true;
            } catch (error) {
                this.is_failed = true;
            } finally {
                this.is_changing_password = false;
            }
        }
    }
};
</script>

<style scoped>

</style>
